(function ( $ ) {

    $(document).ready(function () {

        var $curImg;

        $('.icon-grid .range-slider').on('input',function (e) {
            var $this = $(this);
            var curVal = $this.val() + '%';

            $this.siblings('.cur-value').html( curVal ); // updating .badge element value for current range-slider

            if ( typeof e.originalEvent !== "undefined" ) {
                // check if event was native ( in other words - was NOT triggered by some js code)

                $curImg = $this.closest('.image-position').siblings('.icon-grid-inner').find('.icon-grid__img');

                if ( $this.hasClass('max-width') ) { // updating max-width css property for image
                    $curImg.css('max-width', curVal);
                }
            }
        });

    });
})( jQuery )
